module.exports = __webpack_public_path__ + "img/svg.8e4d3390.svg";